class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.menuToggle = this.querySelector('.site-header__menu-toggle');
    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        this.toggleMobileMenu();
      });
    }

    this.querySelectorAll('.site-header__dropdown').forEach((dropdown) => {
      const trigger = dropdown.querySelector('.site-header__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const wasOpen = dropdown.classList.contains('is-open');
        this.closeAllDropdowns();
        if (!wasOpen) {
          dropdown.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', () => this.closeAllDropdowns());

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.closeAllDropdowns();
      if (this.classList.contains('is-menu-open')) this.toggleMobileMenu();
    });

    // The homepage header is transparent over the hero and turns solid on scroll.
    this.boundScroll = () => this.updateScrollState();
    window.addEventListener('scroll', this.boundScroll, { passive: true });
    this.updateScrollState();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.boundScroll);
  }

  updateScrollState() {
    this.classList.toggle('is-scrolled', window.scrollY > 40);
  }

  closeAllDropdowns() {
    this.querySelectorAll('.site-header__dropdown.is-open').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
      const trigger = dropdown.querySelector('.site-header__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  toggleMobileMenu() {
    const isOpen = this.classList.toggle('is-menu-open');
    this.menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

customElements.define('site-header', SiteHeader);
